import { FormControl, TextField, Typography } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { ReactConfirmProps, confirmable, createConfirmation } from 'react-confirm';
import * as Yup from 'yup';
import { WithChildrenProps } from '../';
import CommentTaskType from '../../enum/CommentTaskType';
import TaskApi from '../../service/TaskApi';
import { ThemeBlue, ThemeBlueDark } from "../../themes/ThemeBlue";
import DefaultButton from '../FormControl/DefaultButton';
import { FormValidationSchema } from '../FormControl/Form/Form';
import FormDialog, { FormDialogNoTheme } from '../FormControl/FormDialog';
import ErrorButton from './../FormControl/ErrorButton';

interface ConfirmationOptions {
    onProceed: () => Promise<any> | any;
    onCancel?: () => any;
    user_id?: number;
    user_name?: string;
    task_id: number;
    auth_user_id: number;
}

interface TaskStatusChangeCommentDialogProps extends WithChildrenProps {
    options: ConfirmationOptions,
    ProceedButton?: React.ComponentType<ButtonProps>
}

interface TaskStatusChangeCommentDialogFormData {
    comment: string;
}

export class TaskStatusChangeCommentDialog extends React.Component<ReactConfirmProps & TaskStatusChangeCommentDialogProps> {

    private taskApi: TaskApi;

    constructor(props: ReactConfirmProps & TaskStatusChangeCommentDialogProps) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.getValidationSchema = this.getValidationSchema.bind(this);
        this.taskApi = new TaskApi();
    }

    async onSubmit(comment: string) {
        const { options, proceed } = this.props;
        const { task_id, user_id, onProceed, auth_user_id } = options;
        const users = [];
        if (user_id) {
            users.push(user_id);
        }
        const saveComment = await this.taskApi.saveComment(task_id, comment, false, auth_user_id, CommentTaskType.PreService, undefined, undefined, users);
        if (saveComment) {
            if ((await Promise.resolve(onProceed())) === false) {
                return;
            }
            if (typeof proceed === 'function') {
                proceed('ok');
            }
        }
    }

    getValidationSchema() {
        const validationSchema: FormValidationSchema<TaskStatusChangeCommentDialogFormData> = {
            comment: Yup.string()
                .trim()
                .required()
                .min(3)
                .label('Comentário')
        }
        return validationSchema;
    }

    render() {
        const { show, dismiss, options } = this.props;
        const { onCancel, user_name } = options;
        var theme = localStorage.getItem("theme");
        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme === 'dark' ? ThemeBlueDark : ThemeBlue}>
                    <FormDialogNoTheme<TaskStatusChangeCommentDialogFormData>
                        show={show}
                        title={'Informe o motivo da mudança de status'}
                        dismiss={() => dismiss()}
                        onSubmit={(values, dirty, errors) => {
                            if (errors && Object.keys(errors).length > 0) {
                                return;
                            }
                            const { comment } = values;
                            if (comment)
                                this.onSubmit(comment);
                        }}
                        initialValues={{ comment: '' }}
                        enableReinitialize={true}
                        maxWidth='sm'
                        fullWidth
                        validationSchema={this.getValidationSchema()}
                    >
                        {({ values, errors, setFieldValue, isSubmitting, handleChange, dirty }) => (
                            <>
                                <FormControl fullWidth variant="outlined" margin='dense'>
                                    <TextField
                                        name="comment"
                                        label={"Motivo"}
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        required
                                        autoFocus
                                        inputProps={{
                                            style: {
                                                resize: 'vertical', overflow: 'auto', height: 165, minHeight: 165, maxHeight: 400
                                            }
                                        }}
                                        value={values.comment}
                                        onChange={handleChange}
                                        error={!!errors.comment && !!dirty.comment}
                                        helperText={!!errors.comment && !!dirty.comment && errors.comment}
                                    />
                                    {user_name && <Typography variant='caption' color='textSecondary'>
                                        {`Comentário será atríbuido para: `}<b>{`${user_name}`}</b>
                                    </Typography>}
                                </FormControl>
                                <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                                    <ErrorButton
                                        size='small'
                                        variant='contained'
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            if (typeof onCancel === 'function') {
                                                onCancel();
                                            }
                                            if (typeof onCancel !== 'function') {
                                                dismiss();
                                            }
                                        }} >
                                        Cancelar
                                    </ErrorButton>
                                    <DefaultButton
                                        size='small'
                                        type='submit'
                                        variant="contained"
                                        disabled={isSubmitting}>
                                        OK
                                    </DefaultButton>
                                </FormControl>
                            </>
                        )}
                    </FormDialogNoTheme>
                </ThemeProvider>
            </StyledEngineProvider>
        );
    }
}

const ConfirmableDialog = confirmable<TaskStatusChangeCommentDialogProps>(TaskStatusChangeCommentDialog);

const confirm = createConfirmation(ConfirmableDialog, 400, document.querySelector('.App'));

export default function taskStatusChangeCommentDialog(options: ConfirmationOptions) {
    // You can pass whatever you want to the component. These arguments will be your Component's props
    return confirm({ options });
}